<div #scrollRegion
     class="chat-conversation"
     role="log"
     aria-live="polite"
     aria-relevant="additions"
     (scroll)="onScroll()">
  <app-chat-message *ngFor="let msg of messages; trackBy: trackById"
                    [message]="msg"
                    (suggestionPick)="suggestionPick.emit($event)"
                    (retry)="retry.emit($event)"></app-chat-message>
</div>

<!-- "New message" badge — shown only when user has scrolled up and a new message arrives -->
<button *ngIf="showNewMessageBadge"
        class="chat-conversation__badge"
        type="button"
        (click)="scrollToBottomFromBadge()"
        [attr.aria-label]="'chatAi.conversation.scrollDown' | translate">
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none"
       stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"
       aria-hidden="true">
    <polyline points="6 9 12 15 18 9"/>
  </svg>
  {{ 'chatAi.conversation.newMessage' | translate }}
</button>
